import classNames from "classnames";
import VerticalCatalogCard from "@components/Features/catalog/vertical-catalog-card/vertical-catalog-card";
import { OffersListProps } from "./types";
import classes from "./offers-list.module.scss";

export const OffersList = ({ className, offers }: OffersListProps) => {
    return (
        <div className={classNames(classes["offers-list"], className)}>
            {offers.map((item) => (
                <VerticalCatalogCard key={item.id} data={item} />
            ))}
        </div>
    );
};